import { posthog, posthogLoaded } from "@/lib/posthog";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { pageTypeFor } from "@/lib/analytics";

export function usePostHogPageview() {
  const location = useLocation();

  useEffect(() => {
    const capture = () => {
      if (!posthogLoaded()) return;
      // page_type y city en cada pageview: el embudo de la lista de espera se
      // mide por tipo de página, no por URL (28-10-2026).
      posthog().capture("$pageview", {
        $current_url: window.location.href,
        path: location.pathname,
        ...pageTypeFor(location.pathname),
      });
    };

    capture();

    // If PostHog is not loaded yet (no consent, or key missing) the call
    // above no-ops. Re-fire once consent is granted so the first pageview
    // after opt-in isn't lost on pages where the user never navigated.
    // PostHog se descarga al dar consentimiento: el primer pageview sale
    // cuando avisa de que está listo.
    window.addEventListener("posthog-ready", capture);
    return () => window.removeEventListener("posthog-ready", capture);
  }, [location.pathname]);
}
